import React, { useEffect } from 'react';
import { AppRouter } from '@/presentation/routes/routes';
import { AuthProvider } from '@/presentation/contexts/AuthContext';
import { ToastProvider, useToast } from '@/presentation/contexts/ToastContext';
import { ToastContainer } from '@/presentation/components/common/Toast';
import { ErrorBoundary } from '@/presentation/components/common/ErrorBoundary';
import { initializeTheme } from '@/shared/utils/theme';
import '@/styles/globals.css';
import '@/styles/variables.css';

const AppContent: React.FC = () => {
  const { toasts, removeToast } = useToast();

  return (
    <>
      <AppRouter />
      <ToastContainer toasts={toasts} onClose={removeToast} />
    </>
  );
};

const AppFallback: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-900 text-white p-8">
    <div className="text-center max-w-md">
      <h1 className="text-xl font-semibold mb-4">Se produjo un error</h1>
      <p className="text-gray-400 mb-6">Recargá la página para intentar de nuevo.</p>
      <button
        type="button"
        onClick={() => window.location.reload()}
        className="px-4 py-2 bg-teal-600 hover:bg-teal-700 rounded-lg"
      >
        Recargar página
      </button>
    </div>
  </div>
);

export const App: React.FC = () => {
  useEffect(() => {
    initializeTheme();
  }, []);

  return (
    <ErrorBoundary fallback={<AppFallback />}>
      <AuthProvider>
        <ToastProvider>
          <AppContent />
        </ToastProvider>
      </AuthProvider>
    </ErrorBoundary>
  );
};
